export const MissionVision = (props) => {
    return (
      <div id="MissionVision">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-6 mission">
              <div className='section-title'>
                <h2>Misión</h2>
              </div>
              <p><h5>Entregar recursos que ayuden a educar.</h5> Nuestra primera misión no es educar hijos ajenos. Es trabajar para reunir, organizar y entregar a las familias, muchos recursos útiles e indispensables, que hagan de la educación en casa una experiencia posible, satisfactoria y próspera.</p>           
            </div>
            <div className="col-xs-12 col-md-6">
              <div className='section-title'>
                <h2>Visión</h2>
              </div>
              <p><h5>Padres e hijos que conviven aprendiendo. </h5> Los chicos asimilando conocimiento para la mente y conductas sanas para su personalidad y futuro. Los papás, capacitándose para estar presentes y ser entrenadores que forjen carácter en toda la familia, para ganarle juntos a la vida.</p>
            </div>
          </div>
        </div>
        <div id="OfertaAcademica"></div>
       </div>
    )
  }
  